import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import maintenanceIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getMaintenance41_2Totals } from "../../../../../apis/Product/UseStageFlow41Api";

const Maintenance41_2Icon = () => (
  <img src={maintenanceIcon} alt="Maintenance Icon" width={76} height={76} />
);

const Maintenance41_2Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalMaintenanceItem, setTotalMaintenanceItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getMaintenance41_2Totals({
        productId,
        setTotals: setTotalMaintenanceItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener('refresh-maintenance-41-2-totals', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-maintenance-41-2-totals', handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`maintenance-41-2-category ${className || ""}`}
      leftBoxProps={{
        icon: <Maintenance41_2Icon />,
        title: t("MAINTENANCE_41_2") || "Maintenance",
        description:
          t("MAINTENANCE_41_2_DESC") ||
          "State regular maintenance activities (e.g. cleaning, inspection, lubrication) to keep the FU functioning during its service life.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_41_2") || "Total for Flow 41.2",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalMaintenanceItem?.impact_totals || null,
        lastUpdated: totalMaintenanceItem?.updated_at
          ? formatDate(totalMaintenanceItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Maintenance41_2Header;

